import json from "../../json/generalSettings/enableConfigTransfer.json";
export default async () => JSON.parse(JSON.stringify(await json));
